"use client";

import { FetchedSolutionData } from "../../../sanity/lib/queries/getSolutionDetails";

import { VideoElement } from "../Video";
import { ImageElement } from "../Image";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { UnstyledLink } from "../link/unstyledLink";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);

export const SolutionDetailHero = ({ solution }: { solution: FetchedSolutionData }) => {
    useGSAP(() => {
        const scrollTriggerSettings = {
            trigger: ".solution-detail-hero",
            start: "top 70%",
            toggleActions: "play none none none",
        };

        gsap.set(".gsap-headline", { y: 50, opacity: 0 });

        gsap.to(".gsap-headline", {
            y: 0,
            opacity: 1,
            scrollTrigger: scrollTriggerSettings,
            stagger: 0.1,
            delay: 0.3,
        });
    });

    return (
        <div className="mx-2.5 md:mx-5 solution-detail-hero intersection-hero">
            {solution.heroAsset &&
                (solution.heroAsset.asset?.[0]._type === "image" ? (
                    <ImageElement
                        width={2560}
                        src={solution.heroAsset.asset?.[0]}
                        alt={solution.heroAsset.alt || ""}
                        className="object-cover md:w-full aspect-hero"
                    />
                ) : (
                    <VideoElement
                        src={solution.heroAsset.asset?.[0].assetUrl?.url || ""}
                        className="object-cover md:w-full aspect-hero"
                    />
                ))}
            <div className="grid grid-cols-2  gap-2.5 md:gap-5 mt-16 mb-14">
                <div className="col-span-2 mb-10 md:col-span-1 md:mb-0">
                    <h1 className="m-headline-1 md:d-headline-1 whitespace-break-spaces gsap-headline">
                        {solution.title}
                    </h1>
                </div>
                <div className="col-span-2 md:col-span-1">
                    <h2 className="hidden mb-2 m-body-m md:d-body-m md:block gsap-headline">
                        {solution.aboutLabel}
                    </h2>
                    <p className="whitespace-pre-line m-body-l md:d-body-l gsap-headline">
                        {solution.about}
                    </p>
                </div>
            </div>

            {solution.industry?.title && (
                <div className="md:hidden">
                    <div className="flex flex-col justify-between col-span-2 gap-2 md:gap-6">
                        <div className="flex gap-2">
                            <p className="md:mb-2 m-body-m md:d-body-m min-w-20">
                                {solution.industryLabel}
                            </p>
                            <p className="mb-4 m-body-l-highlight md:d-body-l md:mb-0">
                                {solution.previewDescription || solution.industry?.title}
                            </p>
                        </div>
                        {(solution.partner?.length || 0) > 0 && (
                            <div className="flex gap-2 pb-4 md:pb-8">
                                <p className="mb-2 m-body-m md:d-body-m min-w-20">
                                    {solution.partnerLabel}
                                </p>
                                <div>
                                    {solution.partner &&
                                        solution.partner.map((partner, index) =>
                                            partner.link.external ? (
                                                <UnstyledLink
                                                    key={index}
                                                    className="m-body-l-highlight md:d-body-l"
                                                    link={partner.link}
                                                />
                                            ) : (
                                                <p key={index}>{partner.title}</p>
                                            ),
                                        )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
